var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrPackage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.015,
    viewBox: "0 0 24 24.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-package",
    d: "M21,8H17a3,3,0,0,0-3,3v5H12V12A6,6,0,0,0,8.893,6.747a4,4,0,1,0-5.786,0A6,6,0,0,0,0,12V23a1,1,0,0,0,2,0V18H22v5a1,1,0,0,0,2,0V11A3,3,0,0,0,21,8ZM4,4A2,2,0,1,1,6,6,2,2,0,0,1,4,4ZM6,8a4,4,0,0,1,4,4v4H2V12A4,4,0,0,1,6,8Zm10,8V11a1,1,0,0,1,1-1h1v1a1,1,0,0,0,2,0V10h1a1,1,0,0,1,1,1v5Z",
    transform: "translate(0 0.015)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrPackage);
export default __webpack_public_path__ + "static/media/fi-rr-package.d60aa8e0.svg";
export { ForwardRef as ReactComponent };